import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import RejectField from '@features/supplier-onboarding/components/RejectField';

import { useSupplierDocuments, useSupplierInfo } from '@store/reducers/supplier-onboarding/OnboardingReducer';

import { getSupplierCertificates } from '@services/supplierOnboardingService';

import { getFileType, getIconByFileType, printApiError } from '@utils/Util';

import { supplierWorkflowSteps } from '@/constants/constant';

const DocumentUpload = ({ setActiveStep }) => {
	const documents = useSupplierDocuments();
	const supplier = useSupplierInfo();
	const [certificates, setCertificates] = useState([]);
	const stepName = 'DOCUMENT_UPLOAD';
	const { id } = useParams();

	useEffect(() => {
		(async () => {
			try {
				const data = await getSupplierCertificates(id);
				setCertificates(data?.map((item) => item.documentResponse));
			} catch (e) {
				printApiError(e);
			}
		})();
	}, []);

	const renderTypeWiseDocuments = (title, fieldName) => {
		let documentList = [];
		if (fieldName === 'supportingDocumentList') {
			documentList = documents[fieldName]?.map((item) => item.documentResponse);
		} else if (fieldName === 'certificates') {
			documentList = certificates;
		} else {
			documentList = documents[fieldName];
		}
		if (documentList.length > 0) {
			return (
				<div className="information-item">
					<p className="regular-14 weight-500 gray_dark_01">{title}</p>
					<div className="all-pdf-file d-flex flex-wrap justify-content-start align-items-center">
						{documentList?.map((item) => {
							let fileType;
							if (item.docUrl) {
								fileType = getFileType(item.docUrl);
							} else {
								fileType = getFileType(item.name);
							}
							return (
								<div
									key={`document_${item.id}`}
									className="single-pdf mb-1 d-flex justify-content-start align-items-center cursor-pointer"
									onClick={() => window.open(item.docUrl, '_blank')}
								>
									<img src={getIconByFileType(fileType)} width={20} />
									<p className="regular-12">{item.name}</p>
								</div>
							);
						})}
						<RejectField name={fieldName} stepName={stepName} />
					</div>
				</div>
			);
		}
	};

	const renderPhotos = (title, fieldName) => {
		let photoList;
		if (fieldName === 'factoryCoverPhoto') {
			photoList = [documents[fieldName]];
		} else {
			photoList = documents[fieldName] || [];
		}
		if (photoList.length > 0) {
			return (
				<div className="information-item factory-photos">
					<p className="regular-14 weight-500 gray_dark_01">{title}</p>
					<div className="images cursor-pointer">
						{photoList?.map((item) => (
							<img
								key={`photo_${item.id}`}
								src={item.docUrl}
								alt=""
								onClick={() => window.open(item.docUrl, '_blank')}
							/>
						))}
						<RejectField name={fieldName} stepName={stepName} />
					</div>
				</div>
			);
		}
	};

	return (
		<div className="supplier-all-document">
			<h3 className="title weight-700 gray_dark_01">Documents Upload</h3>
			{renderTypeWiseDocuments(
				'Additional Information (Excel/PDF)',
				'additionalInformationDocumnetList'
			)}
			{renderTypeWiseDocuments('Trade License*', 'tradeLicenseList')}
			{renderTypeWiseDocuments('Factory License*', 'factoryLicenseList')}
			{renderTypeWiseDocuments('TIN Certificate*', 'tinCertificateList')}
			{supplier?.profileImageDocUrl && renderPhotos('Factory Cover  Photo*', 'factoryCoverPhoto')}
			{renderPhotos('Factory Photos', 'factoryPhotoList')}
			{renderTypeWiseDocuments('Supporting Documents', 'supportingDocumentList')}
			{renderTypeWiseDocuments('Compliance', 'certificates')}
			<div className="submit-button">
				<button
					className="button size32 w-100"
					onClick={() => setActiveStep(supplierWorkflowSteps.CAPACITY_INFORMATION)}
				>
					Next
				</button>
			</div>
		</div>
	);
};

export default DocumentUpload;
